import React, { useEffect, useState } from "react";
import "./TicketCollectorModal.css";
import ModalBackground from "../shared/components/ModalBackground";

export default function TicketCollectorModal({ onClose, item }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Trigger slide-up animation
    setVisible(true);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300); // Wait for animation to finish
  };

  return (
    <div className="purchase-modal-overlay" onClick={handleClose}>
         <div className={`purchase-card ${visible ? "visible" : ""}`}>
      <div
        className={`purchase-modal-sheet ${visible ? "visible" : ""}`}
        onClick={(e) => e.stopPropagation()} // prevent close on content click
      >
       
        <div className="purchase-modal-header" style={{ position: 'relative', overflow: 'visible' }}>
          <ModalBackground />
          <h2 className="purchase-modal-title" style={{ position: 'relative', zIndex: 1 }}>Confirm purchase</h2>
          <img className="purchase-modal-close" src="/close.png" onClick={handleClose} style={{ position: 'absolute', zIndex: 1 }}></img>
        </div>

        <div className="purchase-modal-content">
          <div className="purchase-images">
          <img src="./arrow-left.svg" alt="Item" className="purchase-arrow" />
          <img src={item.img} alt="Item" className="purchase-modal-image" />
          <img src="arrow-right.svg" alt="Item" className="purchase-arrow" />
          </div>
          <div className="purchase-modal-popular">45%</div>
          <div className="purchase-modal-quantity">{item.label}</div>
          
          <div className="purchases-div">
          <div className="purchase-modal-old-price">{item.price}</div>
          <div className="purchase-modal-new-price">{item.price}</div>
          <p className="purchase-modal-desc">
            First Purchase Discount
          </p>
          </div>
        </div>

        <div className="purchase-modal-buttons">
          <button className="app-btn app-btn--purple">Buy for GRAM</button>
          <button className="app-btn app-btn--purple">Buy for STARS</button>
        </div>
      </div>
      </div>
    </div>
  );
}
